<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-swipe`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2h24a2 2 0 011.994 1.85L31 4v40a2 2 0 01-1.85 1.995L29 46H5a2 2 0 01-1.995-1.85L3 44V4a2 2 0 011.85-1.995L5 2h24H5zm22 4H7v36h20V6zm10 3a1 1 0 011 1v30a1 1 0 01-1 1h-2a1 1 0 01-1-1V10a1 1 0 011-1h2zm7 5a1 1 0 011 1v20a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconSwipe',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
